// controllers/clipboard_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["source"];

  copy() {
    const text = this.hasSourceTarget
      ? this.sourceTarget.textContent.trim()
      : this.element.textContent.trim();

    if (!text) return;

    navigator.clipboard
      .writeText(text)
      .then(() => this.successAlert())
      .catch((err) => this.errorAlert(err));
  }

  // ─── private helpers ───────────────────────────────────────────────────────
  successAlert() {
    /*  Classic SweetAlert (≤ v1) global `swal`:
        swal(title, text, type, options?)
    */
    swal({
      title: "Copied!",
      type: "success",
      timer: 1500,
      showConfirmButton: false,
    });
  }

  errorAlert(err) {
    console.error("Clipboard error:", err);

    swal(
      "Copy failed",
      err?.message || "Unable to write to clipboard",
      "error"
    );
  }
}
